import React from 'react';
import { StudyPlanCheckpoint } from '../types';

import PrioritizedAssessmentCheckpoint from '@magoosh/gre/organisms/checkpoints/prioritized_assessment';
import PrioritizedPracticeTestCheckpoint from '@magoosh/gre/organisms/checkpoints/prioritized_practice_test';
import PrioritizedTestDayCheckpoint from '@magoosh/gre/organisms/checkpoints/prioritized_test_day';

import PrioritizedRefreshCheckpoint from './prioritized_refresh';

interface Props {
  deferAssessment: () => void;
  dismissRefresh: () => void;
  prioritizedCheckpoint: StudyPlanCheckpoint;
  refreshPlan: () => void;
  testDate?: string;
}

const PrioritizedCheckpoint: React.FC<Props> = (props) => {
  const {
    deferAssessment,
    dismissRefresh,
    prioritizedCheckpoint,
    refreshPlan,
    testDate
  } = props;

  switch (prioritizedCheckpoint.type) {
    case 'Practice Test':
      return <PrioritizedPracticeTestCheckpoint checkpoint={prioritizedCheckpoint} />;
    case 'Test Day':
      return <PrioritizedTestDayCheckpoint testDate={testDate} />;
    case 'Refresh':
      return <PrioritizedRefreshCheckpoint
        checkpoint={prioritizedCheckpoint}
        dismissRefresh={dismissRefresh}
        refreshPlan={refreshPlan}
      />;
    case 'Assessment':
      return <PrioritizedAssessmentCheckpoint
        allowDefer={prioritizedCheckpoint.allowDefer}
        checkpoint={prioritizedCheckpoint}
        deferAssessment={deferAssessment}
      />;
  };
}

export default PrioritizedCheckpoint;
